"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { BLOG_CARD_GRADIENTS, BLOG_TAGS } from "@/constants/blog.constants";
import { useBlogList } from "@/hooks/useBlogList";
import type { BlogPostListItem } from "@/types";
import { formatDate } from "@/utils/formatDate";
type Props = {
  posts: BlogPostListItem[];
};
export default function BlogList(t0) {
  const $ = _c(12);
  const {
    posts
  } = t0;
  const {
    active,
    setActive,
    visiblePosts,
    featured,
    rest
  } = useBlogList(posts);
  let t1;
  if ($[0] !== active || $[1] !== setActive) {
    t1 = BLOG_TAGS.map(tag => {
      const isActive = tag === active;
      return <button key={tag} type="button" onClick={() => setActive(tag)} aria-pressed={isActive} className={`rounded-full border px-4 py-1.5 text-sm font-medium transition ${isActive ? "border-transparent bg-[var(--accent)] text-[#07111f] shadow-[0_0_18px_-6px_var(--accent)]" : "border-[var(--stroke)] text-[var(--muted)] hover:border-[var(--accent)] hover:text-[var(--text)]"}`}>{tag}</button>;
    });
    $[0] = active;
    $[1] = setActive;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <section className="reveal-section mt-12 flex flex-wrap gap-2">{t1}</section>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== featured || $[6] !== rest || $[7] !== visiblePosts.length) {
    t3 = visiblePosts.length === 0 ? <div className="reveal-section mt-16 rounded-2xl border border-[var(--stroke)] bg-[var(--panel)]/60 p-12 text-center"><p className="text-lg font-semibold">No posts in this category yet.</p><p className="mt-2 text-sm text-[var(--muted)]">Try another tag.</p></div> : <>{featured ? <section className="reveal-section group mt-10 overflow-hidden rounded-2xl border border-[var(--stroke)]/80 bg-[linear-gradient(160deg,rgba(255,255,255,0.14),rgba(255,255,255,0.04))] backdrop-blur-xl ring-1 ring-white/10 transition hover:border-[var(--accent)]/40 hover:shadow-[0_24px_70px_-36px_var(--accent)]"><div className="grid gap-0 md:grid-cols-2"><div className="p-4"><div className="relative flex h-72 items-end overflow-hidden rounded-xl border border-white/10 bg-[linear-gradient(135deg,#1f2c5a,#0d1b4a,#08123a)] p-6 md:h-full"><span className="rounded-md bg-black/40 px-3 py-1 text-xs font-medium text-white backdrop-blur">Featured</span></div></div><div className="space-y-4 p-8 md:p-10"><p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent)]">{featured.category?.name ?? "Article"}</p><h2 className="text-3xl font-bold leading-tight md:text-4xl">{featured.title}</h2>{featured.excerpt ? <p className="text-[var(--muted)]">{featured.excerpt}</p> : null}<div className="flex items-center gap-3 text-xs text-[var(--subtle)]"><span>{formatDate(featured.published_at)}</span><span>•</span><span>{featured.read_minutes} min read</span></div><Link href={`/blog/${featured.slug}`} className="mt-3 border-2 border-[var(--accent)]/60 rounded-2xl px-2 py-1 inline-flex w-fit items-center gap-1 text-sm font-semibold text-[var(--accent)] transition-all duration-300 group-hover:gap-2">Read More</Link></div></div></section> : null}<section className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">{rest.map(_temp)}</section></>;
    $[5] = featured;
    $[6] = rest;
    $[7] = visiblePosts.length;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(post, i) {
  return <div key={post.id} className="group relative cursor-default flex h-full flex-col overflow-hidden rounded-2xl border border-[var(--stroke)]/80 bg-[linear-gradient(160deg,rgba(255,255,255,0.14),rgba(255,255,255,0.04))] backdrop-blur-xl ring-1 ring-white/10 transition duration-300 hover:-translate-y-1 hover:border-[var(--accent)]/50 hover:shadow-[0_20px_60px_-30px_var(--accent)]"><div aria-hidden={true} className="pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full opacity-0 blur-3xl transition duration-500 group-hover:opacity-50" style={{
      background: "radial-gradient(circle, var(--accent-soft), transparent 70%)"
    }} /><div className="px-4 pt-4"><div className={`relative h-44 overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br ${BLOG_CARD_GRADIENTS[i % BLOG_CARD_GRADIENTS.length]}`}><div className="neural-bg opacity-20" />{post.category ? <span className="absolute left-3 top-3 rounded-md bg-black/40 px-2 py-1 text-[10px] font-medium uppercase tracking-wider text-white backdrop-blur">{post.category.name}</span> : null}</div></div><div className="flex flex-1 flex-col gap-3 p-5"><h3 className="text-base font-bold leading-snug text-[var(--text)] transition group-hover:text-[var(--accent)]">{post.title}</h3>{post.excerpt ? <p className="line-clamp-2 flex-1 text-sm text-[var(--muted)]">{post.excerpt}</p> : null}<Link href={`/blog/${post.slug}`} className="mt-3 border-2 border-[var(--accent)]/60 rounded-2xl px-2 py-1 inline-flex w-fit items-center gap-1 text-sm font-semibold text-[var(--accent)] transition-all duration-300 group-hover:gap-2">Read More</Link><div className="flex items-center justify-between border-t border-[var(--stroke)] pt-3 text-xs text-[var(--subtle)]"><span>{formatDate(post.published_at)}</span><span>{post.read_minutes} min read</span></div></div></div>;
}